module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "copyright"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Published by"), _c('br'), _vm._v(" Grub Street"), _c('br'), _vm._v(" 4 Rainham Close"), _c('br'), _vm._v(" London"), _c('br'), _vm._v(" SW11 6SS")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2004 Grub Street, London"), _c('br'), _vm._v(" Text copyright © 2004 Graham Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v(" Thomas, Graham")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Furies and Fireflies over Korea : the story of the men of the"), _c('br'), _vm._v(" Fleet Air Arm, RAF and Commonwealth who defended South Korea, 1950-1953 ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1. Great Britain. Royal Navy. Fleet Air Arm – History ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("2. Korean War, 1950-1953 – Aerial operations, British ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("I. Title"), _c('br'), _vm._v(" 951.9’04248 ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISBN 1 904010 04 0"), _c('br'), _vm._v(" ePUB ISBN: 9781909166417")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication my be reproduced,"), _c('br'), _vm._v(" stored in a retrieval system, or transmitted in any form or by any means,"), _c('br'), _vm._v(" electronic, mechanical, photocopying, recording or otherwise, without"), _c('br'), _vm._v(" the prior permission of the copyright owner. ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Typeset by Pearl Graphics, Hemel Hempstead ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed and bound in Great Britain by Biddles Ltd, Kings Lynn")]), _vm._v(" "), _c('h1', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("This book is dedicated to all the Fleet Air Arm pilots who flew with such distinction during the Korean War. It is especially dedicated to the men who lost their lives flying over enemy territory in the line of duty. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0